/* ==========================================================================
   Copargo - Combinaciones inexistentes en el selector de variantes
   --------------------------------------------------------------------------
   Custom de Copargo. No toca global.min.js: envuelve el metodo
   updateOptions() de <hdt-variant-picker> desde afuera.

   El problema (Ecomus v2.2.2): al hacer clic en un valor, el tema pide la
   seccion a Shopify con ?option_values=<valor clicado + valores marcados>
   y reemplaza el selector con lo que vuelve. Si esa combinacion no existe
   (ej. "15 unidades" + "Klerat Pellet 50 G"), Shopify responde con la
   variante de respaldo (la primera) y el tema la toma tal cual: el valor
   clicado queda sin marcar, la etiqueta, el precio y el boton siguen en la
   variante anterior, y solo cambia la disponibilidad del otro eje.

   Lo que hace este archivo: si la variante que volvio no lleva el valor
   clicado, elige la variante que si lo lleva y que mas se parece a la
   seleccion anterior (prefiriendo las disponibles), marca sus valores y
   vuelve a pedir la seccion. El resto del flujo del tema (precio, boton,
   URL, media) sigue igual porque corre despues sobre la variante correcta.
   ========================================================================== */

(function () {
  "use strict";

  var productCache = {};

  function loadProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch(Shopify.routes.root + "products/" + handle + ".js")
        .then(function (response) {
          if (!response.ok) throw new Error(handle + " .js " + response.status);
          return response.json();
        })
        .catch(function (error) {
          delete productCache[handle];
          throw error;
        });
    }
    return productCache[handle];
  }

  function pickVariant(variants, index, value, previous, onlyAvailable) {
    var candidates = variants.filter(function (variant) {
      return variant.options[index] === value;
    });
    var available = candidates.filter(function (variant) {
      return variant.available;
    });
    if (onlyAvailable || available.length) candidates = available;

    var best = null;
    var bestScore = -1;
    candidates.forEach(function (variant) {
      var score = 0;
      variant.options.forEach(function (option, i) {
        if (i !== index && previous && previous[i] === option) score++;
      });
      if (score > bestScore) {
        best = variant;
        bestScore = score;
      }
    });
    return best;
  }

  customElements.whenDefined("hdt-variant-picker").then(function () {
    var Picker = customElements.get("hdt-variant-picker");
    var originalUpdateOptions = Picker.prototype.updateOptions;

    Picker.prototype.updateOptions = async function () {
      var previous = this.currentVariant && this.currentVariant.options;
      await originalUpdateOptions.call(this);

      var index = this.clickedCurrentIndex;
      var value = this.clickedCurrentValue;
      var current = this.currentVariant;
      if (isNaN(index) || value == null || !current || current.options[index] === value) return;

      try {
        var product = await loadProduct(this.getAttribute("handle"));
        var target = pickVariant(product.variants, index, value, previous, this.hideSoldOutVariants);
        if (!target) return;

        var fieldsets = this.querySelectorAll("fieldset[data-index]");
        target.options.forEach(function (option, i) {
          if (!fieldsets[i]) return;
          var input = Array.prototype.find.call(
            fieldsets[i].querySelectorAll("input[is-value][data-value-id]"),
            function (el) {
              return el.value === option;
            }
          );
          if (input) input.checked = true;
        });

        await originalUpdateOptions.call(this);
      } catch (error) {
        console.error("copargo-variant-fallback:", error);
      }
    };
  });
})();
